import type { IButtonsBarV2 } from "@/design-system/buttons-bar";
import { RulesModalResources } from "@/src/cashback/RuleModal.Resources";
import { RulesModalResourcesEn } from "@/src/cashback/RuleModal.Resources.En";
import { languageSelector } from "@/src/contexts";
import type { IComponent } from "@Components/Component";
import { urlFormat } from "@Components/Modules/Helpers";
import { LinkFromApp } from "@Routes/ClickLinkLinks";
import * as stylex from "@stylexjs/stylex";

import { type IRulesModal, RulesModal } from "../cashback/RulesModal";

import * as css from "./MobileWebView.module.css";

export interface IMobileWebView extends IComponent {
    rulesModal: IRulesModal;
    link: string;
    appUserId: string;
}

export const MobileWebView = (props: IMobileWebView) => {
    const resources = languageSelector(RulesModalResources, RulesModalResourcesEn);

    const customButtonsBar: IButtonsBarV2 = {
        nextButtonText: resources.btnNext,
        nextButton: {
            as: "a",
            variant: "magentaRound",
            size: "M",
            eventName: undefined,
            href: urlFormat(
                LinkFromApp,
                { brandId: props.rulesModal.brandId, appUserId: props.appUserId, link: props.link },
                true,
            ),
            isExternal: true,
            styleX: styles.buttonNext,
        },
        cancelButton: null,
        styleX: styles.buttonsContainer,
    };

    return (
        <div className={css.mobileWebViewComponent}>
            {props.rulesModal && (
                <RulesModal
                    {...props.rulesModal}
                    buttonsBar={customButtonsBar}
                    withoutModal
                    showAd={false}
                    trackingActive={false}
                />
            )}
        </div>
    );
};

const styles = stylex.create({
    buttonNext: {
        width: "100%",
    },
    buttonsContainer: {
        paddingBottom: 50,
    },
});
